import { render, staticRenderFns } from "./AddItem.vue?vue&type=template&id=81089398&scoped=true"
import script from "./AddItem.vue?vue&type=script&lang=js"
export * from "./AddItem.vue?vue&type=script&lang=js"
import style0 from "./AddItem.vue?vue&type=style&index=0&id=81089398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81089398",
  null
  
)

export default component.exports